import { NamespacedImageKeys } from '@bonanza-social/moonlight';
import { InboxMessageType } from '../state';

export const inboxMessageIconMap: Record<
  InboxMessageType,
  NamespacedImageKeys
> = {
  Cash: 'common.Cash',
  Bonus: 'common.Cash',
  Coins: 'common.Coin',
  CommunityJackpot: 'common.Jackpot',
  DailyGift: 'common.GiftBox',
  'Free Spins': 'common.Spins',
  InstantWheel: 'common.Wheel',
  Level: 'common.LevelUp',
  LadderProgress: 'common.Megaphone',
  Wheel: 'common.BonanzaWheel',
  Scratcher: 'common.BonanzaScratchcard',
  Status: 'common.Megaphone',
};
